import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuListItemsComponent } from './components/menu-list-items/menu-list-items.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [MenuListItemsComponent],
  imports: [CommonModule, RouterModule],
  exports: [MenuListItemsComponent],
})
export class MobileFixedMenuModule {}
